export default {
	notPermitted: 'Puudub õigus selle toimingu tegemiseks',
	confirmDelete: 'Kas olete kindel, et soovite seda kustutada?',
	successfullyDeleted: 'Edukalt kustutatud!',
	successfullyEdited: 'Edukalt muudetud!',
	successfullyAdded: 'Edukalt lisatud!',
	loseUnsavedChanges: 'Salvestamata muudatused lähevad kaduma!',
	unsavedChanges: 'Teil on salvestamata muudatused!',
	discard: 'Kas olete kindel, et soovite neist loobuda?',
	loading: 'Laadimas',
	result: 'Tulemus',
	search: 'Otsi',
	created: 'Loodud',
	complete: 'Lõpeta',
	public: 'Avalik',
	unspecified: 'Määratlemata',
	yes: 'Jah',
	no: 'Ei',
	remove: 'Eemalda',
	nothing: 'Puudub',
	close: 'Sulge',
	none: 'Puudub',
	all: 'Kõik',
	own: 'Oma',
	confirm: 'Kinnita',
	add: 'Lisa',
	edit: 'Muuda',
	delete: 'Kustuta',
	view: 'Vaata',
	save: 'Salvesta',
	reset: 'Lähtesta',
	comment: 'Kommentaar',
	addComment: 'Sisesta kommentaar',
	cancel: 'Tühista',
	keep: 'Jäta',
	leave: 'Lahku',
	select: 'Vali',
	name: 'Nimi',
	continue: 'Jätka',
	limit: 'ja {0} veel',
	validField: 'Väli ei tohi olla tühi!',
	validName: 'Nimi on kohustuslik!',
	validInstance: 'Asutus on kohustuslik!',
	filterOpt: 'Tulpade ja filtrite valikud',
	connectionOpt: 'Seoste andmetulpade valikud',
	connectionObjOpt: 'Seotud objektide filtrite valikud',
	import: 'Impordi',
	export: 'Ekspordi',
	publish: 'Avalikusta',
	undefined: 'Määramata',
	clearFilters: 'Tühjenda kõik filtrid',
	theme: 'Stiil',
	user: 'Kasutajal',
	role: 'Rollil',
	giveAwayResponsibilities: 'Muuda vastutajat',
	successfullyResponsibilityChanged: 'Vastutus edukalt muudetud',
	replaceRoleResponsibilities: 'Kanna vastutus üle teisele rollile',
}
